"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDataCatalogInMemoryCache = exports.apolloClientGenerator = exports.queryOptions = void 0;
const context_1 = require("@apollo/client/link/context");
const client_1 = require("@apollo/client");
const CookieHelpers_1 = require("./utilities/CookieHelpers");
const DEFAULT_LINK_OPTIONS = { uri: '/api/exp/metadata/graphql', credentials: 'same-origin' };
const XSRF_COOKIE_NAME = 'XSRF-TOKEN';
const XSRF_PROTECTION_HEADER_NAME = 'X-XSRF-TOKEN';
// Cache is disabled because of TFS 882415.
const useApolloCache = false;
exports.queryOptions = {
    fetchPolicy: useApolloCache ? 'cache-first' : 'no-cache',
    errorPolicy: 'all', // 'none' is the default, but we want all errors passed through to our handlers
};
function getXSRFHeaderLink(xsrfToken) {
    const XSRFHeaderLink = (0, context_1.setContext)((_, { headers }) => {
        const token = xsrfToken || (0, CookieHelpers_1.getCookieValue)(window.document.cookie, XSRF_COOKIE_NAME);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const newHeaders = Object.assign({}, headers);
        if (token) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            newHeaders[XSRF_PROTECTION_HEADER_NAME] = token;
        }
        return {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            headers: newHeaders,
        };
    });
    return XSRFHeaderLink;
}
/**
 * Create an apollo client to query the data catalog GraphQL API
 * @param linkOptions describes how to access the data catalog GraphQL API service
 */
function apolloClientGenerator(linkOptions = DEFAULT_LINK_OPTIONS, xsrfToken) {
    return new client_1.ApolloClient({
        link: getXSRFHeaderLink(xsrfToken).concat((0, client_1.createHttpLink)(linkOptions)),
        cache: createDataCatalogInMemoryCache(),
        defaultOptions: { query: exports.queryOptions, watchQuery: exports.queryOptions },
    });
}
exports.apolloClientGenerator = apolloClientGenerator;
/**
 * Creates an in-memory cache for responses from the data catalog GraphQL API
 *
 * TODO: update @tableau/data-catalog-api-schema to generate possible types, see https://www.apollographql.com/docs/react/data/fragments/#generating-possibletypes-automatically
 * import * as introspectionQueryResultData from '@tableau/data-catalog-api-schema/dist/fragments.json';
 */
function createDataCatalogInMemoryCache() {
    return new client_1.InMemoryCache();
}
exports.createDataCatalogInMemoryCache = createDataCatalogInMemoryCache;
//# sourceMappingURL=apolloClientGenerator.js.map